import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, CartIcon, ShieldIcon, BookIcon, PawIcon } from './Icons';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offer" className="relative w-full py-20 sm:py-28 overflow-hidden" style={{
    background: 'linear-gradient(180deg, #111a11 0%, #0a0f0a 40%, #111a11 100%)'
  }} aria-label="Get the bundle" data-id="element-208">
      <div className="max-w-4xl mx-auto px-5 sm:px-8" data-id="element-209">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-210">
          <p className="font-sans text-xs sm:text-sm tracking-[0.2em] uppercase text-gold/70 mb-4" data-id="element-211">
            Limited Time Offer
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-cream leading-tight" data-id="element-212">
            Get "The Longevity Bowl:
            <br data-id="element-213" />
            <span className="text-gold" data-id="element-214">Giant Breed Blueprint"</span> Today
          </h2>
        </motion.div>

        {/* Product mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8
      }} className="flex justify-center mb-16" data-id="element-215">
          <img src="https://cdn.magicpatterns.com/uploads/qmEmSdmUzD1xTcxQ7D3wih/Mockup.png" alt="The Longevity Bowl ebook displayed on tablet and phone, showing the complete digital bundle with bonus materials" className="w-full max-w-xl rounded-lg" data-id="element-216" />
        </motion.div>

        {/* Value stack */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="bg-bg-card/70 border border-white/5 rounded-2xl p-6 sm:p-10 mb-12" data-id="element-217">
          <h3 className="font-serif text-xl sm:text-2xl font-bold text-cream mb-8 text-center" data-id="element-218">
            Everything You Get Today
          </h3>

          <div className="space-y-5" data-id="element-219">
            {/* Main Blueprint */}
            <div className="flex items-start gap-4 pb-5 border-b border-white/5" data-id="element-220">
              <div className="flex-shrink-0 mt-0.5" data-id="element-221">
                <div className="w-7 h-7 rounded-full bg-gold/20 flex items-center justify-center" data-id="element-222">
                  <BookIcon className="w-4 h-4 text-gold" data-id="element-223" />
                </div>
              </div>
              <div className="flex-1 min-w-0" data-id="element-224">
                <p className="font-sans font-semibold text-cream text-base sm:text-lg" data-id="element-225">
                  The Main Blueprint
                </p>
                <p className="font-sans text-sm text-cream-muted mt-0.5" data-id="element-226">
                  The full 60-page longevity manual
                </p>
              </div>
              <p className="font-sans text-sm text-cream-muted line-through flex-shrink-0" data-id="element-227">
                $97
              </p>
            </div>

            {/* Bonus 1 */}
            <div className="flex items-start gap-4 pb-5 border-b border-white/5" data-id="element-228">
              <div className="flex-shrink-0 mt-0.5" data-id="element-229">
                <div className="w-7 h-7 rounded-full bg-green-deep/30 flex items-center justify-center" data-id="element-230">
                  <CheckIcon className="w-4 h-4 text-green-accent" data-id="element-231" />
                </div>
              </div>
              <div className="flex-1 min-w-0" data-id="element-232">
                <p className="font-sans text-xs uppercase tracking-wider text-gold/60 mb-0.5" data-id="element-233">
                  Bonus #1
                </p>
                <p className="font-sans font-semibold text-cream text-base sm:text-lg" data-id="element-234">
                  The 15-Minute Meal Prep Guide
                </p>
              </div>
              <p className="font-sans text-sm text-cream-muted line-through flex-shrink-0" data-id="element-235">
                $27
              </p>
            </div>

            {/* Bonus 2 */}
            <div className="flex items-start gap-4 pb-5 border-b border-white/5" data-id="element-236">
              <div className="flex-shrink-0 mt-0.5" data-id="element-237">
                <div className="w-7 h-7 rounded-full bg-green-deep/30 flex items-center justify-center" data-id="element-238">
                  <CheckIcon className="w-4 h-4 text-green-accent" data-id="element-239" />
                </div>
              </div>
              <div className="flex-1 min-w-0" data-id="element-240">
                <p className="font-sans text-xs uppercase tracking-wider text-gold/60 mb-0.5" data-id="element-241">
                  Bonus #2
                </p>
                <p className="font-sans font-semibold text-cream text-base sm:text-lg" data-id="element-242">
                  The Supermarket Cheat Sheet
                </p>
                <p className="font-sans text-sm text-cream-muted mt-0.5" data-id="element-243">
                  Costco/Walmart/Aldi Edition
                </p>
              </div>
              <p className="font-sans text-sm text-cream-muted line-through flex-shrink-0" data-id="element-244">
                $67
              </p>
            </div>

            {/* Bonus 3 */}
            <div className="flex items-start gap-4 pb-5 border-b border-white/5" data-id="element-245">
              <div className="flex-shrink-0 mt-0.5" data-id="element-246">
                <div className="w-7 h-7 rounded-full bg-green-deep/30 flex items-center justify-center" data-id="element-247">
                  <CheckIcon className="w-4 h-4 text-green-accent" data-id="element-248" />
                </div>
              </div>
              <div className="flex-1 min-w-0" data-id="element-249">
                <p className="font-sans text-xs uppercase tracking-wider text-gold/60 mb-0.5" data-id="element-250">
                  Bonus #3
                </p>
                <p className="font-sans font-semibold text-cream text-base sm:text-lg" data-id="element-251">
                  The "Poison List" (Hidden Toxins)
                </p>
              </div>
              <p className="font-sans text-sm text-cream-muted line-through flex-shrink-0" data-id="element-252">
                $47
              </p>
            </div>

            {/* Bonus 4 */}
            <div className="flex items-start gap-4 pb-5 border-b border-white/5" data-id="element-253">
              <div className="flex-shrink-0 mt-0.5" data-id="element-254">
                <div className="w-7 h-7 rounded-full bg-green-deep/30 flex items-center justify-center" data-id="element-255">
                  <CheckIcon className="w-4 h-4 text-green-accent" data-id="element-256" />
                </div>
              </div>
              <div className="flex-1 min-w-0" data-id="element-257">
                <p className="font-sans text-xs uppercase tracking-wider text-gold/60 mb-0.5" data-id="element-258">
                  Bonus #4
                </p>
                <p className="font-sans font-semibold text-cream text-base sm:text-lg" data-id="element-259">
                  The "Itchy Dog" Protocol
                </p>
              </div>
              <p className="font-sans text-sm text-cream-muted line-through flex-shrink-0" data-id="element-260">
                $27
              </p>
            </div>

            {/* Bonus 5 */}
            <div className="flex items-start gap-4" data-id="element-261">
              <div className="flex-shrink-0 mt-0.5" data-id="element-262">
                <div className="w-7 h-7 rounded-full bg-green-deep/30 flex items-center justify-center" data-id="element-263">
                  <CheckIcon className="w-4 h-4 text-green-accent" data-id="element-264" />
                </div>
              </div>
              <div className="flex-1 min-w-0" data-id="element-265">
                <p className="font-sans text-xs uppercase tracking-wider text-gold/60 mb-0.5" data-id="element-266">
                  Bonus #5
                </p>
                <p className="font-sans font-semibold text-cream text-base sm:text-lg" data-id="element-267">
                  Giant Breed Joint Rescue
                </p>
              </div>
              <p className="font-sans text-sm text-cream-muted line-through flex-shrink-0" data-id="element-268">
                $27
              </p>
            </div>
          </div>
        </motion.div>

        {/* Pricing + CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="text-center" data-id="element-269">
          {/* Total value */}
          <div id="pricing" data-id="element-270" />
          <p className="font-sans text-sm uppercase tracking-wider text-cream-muted mb-2" data-id="element-271">
            Total Value
          </p>
          <p className="font-serif text-3xl sm:text-4xl font-bold text-cream-muted line-through mb-6" data-id="element-272">
            $292
          </p>

          {/* Actual price */}
          <p className="font-sans text-sm uppercase tracking-wider text-gold/80 mb-3" data-id="element-273">
            Get the Entire Bundle Today for Only
          </p>
          <div className="flex items-baseline justify-center gap-4 mb-3" data-id="element-274">
            <span className="font-serif text-2xl sm:text-3xl font-bold text-cream-muted/60 line-through" data-id="element-275">
              $47.00
            </span>
            <span className="font-serif text-6xl sm:text-7xl md:text-8xl font-bold text-gold" data-id="element-276">
              $6.39
            </span>
          </div>
          <p className="font-sans text-sm sm:text-base text-cream-muted mb-10 flex items-center justify-center gap-2" data-id="element-277">
            <ShieldIcon className="w-4 h-4 text-gold flex-shrink-0" data-id="element-278" />
            Join 5,000+ dog owners fighting back — for the price of a coffee.
            <PawIcon className="w-4 h-4 text-gold flex-shrink-0" data-id="element-279" />
          </p>

          {/* CTA Button */}
          <a href="https://govitalpaw.com/cart/46119729365180:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="group inline-flex items-center justify-center gap-3 px-10 sm:px-14 py-4 sm:py-5 bg-gold text-bg-primary font-sans font-bold text-base sm:text-lg rounded-lg tracking-wide transition-all duration-300 hover:bg-gold-bright hover:shadow-[0_0_40px_rgba(200,168,78,0.35)] animate-pulse-slow" aria-label="Get instant access for $6.39" data-id="element-280">
            <CartIcon className="w-5 h-5 transition-transform duration-300 group-hover:-translate-y-0.5" data-id="element-281" />
            GET INSTANT ACCESS — $6.39
          </a>

          {/* Trust line */}
          <div className="flex items-center justify-center gap-2 mt-6" data-id="element-282">
            <ShieldIcon className="w-4 h-4 text-green-accent" data-id="element-283" />
            <p className="font-sans text-xs sm:text-sm text-cream-muted" data-id="element-284">
              30-Day Money-Back Guarantee — Zero Risk
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}